import { render, staticRenderFns } from "./customerAddress.vue?vue&type=template&id=e94dbacc&"
import script from "./customerAddress.vue?vue&type=script&lang=js&"
export * from "./customerAddress.vue?vue&type=script&lang=js&"
import style0 from "./customerAddress.vue?vue&type=style&index=0&id=e94dbacc&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports